<span
  #copyButtonText
  [attr.role]="exposesButtonRole(copyButtonText) ? 'button' : null"
  [attr.tabindex]="exposesButtonRole(copyButtonText) ? 0 : null"
  [attr.aria-label]="
    exposesButtonRole(copyButtonText)
      ? copiedToClipboard
        ? copiedText
        : copyText
      : null
  "
  (keydown)="onKeydown($event)">
  <ng-content></ng-content>
</span>
@if (copyButtonText?.children.length === 0) {
  @if (iconClass) {
    <i [ngClass]="iconClass"></i>
  }
  <input
    type="button"
    class="btn"
    [ngClass]="btnClass"
    value="{{ copiedToClipboard ? copiedText : copyText }}" />
}
